document.querySelectorAll('variant-selection').forEach((el) => {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'variant') {
        const newVariant = el.getAttribute('variant');
        console.log('Variant changed to:', newVariant);

        const variantId = parseInt(newVariant, 10);
        const matchedItem = window.variant_preorder_list.find(item => item.id === variantId);

        const product_block_form = el.parentElement;
        const button = product_block_form.querySelector('button.product-form--atc-button');
        const product_main = product_block_form.closest('.product-main');
        const product_badge = product_main.querySelector(".cstm-badge--pre-order");
        // console.log(button)
        // console.log(product_badge)
        if (button && product_badge) {
          // console.log("swhoing")
          requestAnimationFrame(() => {
            const span = button.querySelector('span');
            const isPreorder = !!matchedItem;

            // Update button text
            if (span) {
              span.textContent = isPreorder ? 'PRE ORDER NOW' : 'ADD TO CART';
            } else {
              button.textContent = isPreorder ? 'PRE ORDER NOW' : 'ADD TO CART';
              // console.log("what?")
            }

            // Toggle badge visibility
            if (isPreorder) {
              product_badge.classList.remove("hide-this");
            } else {
              product_badge.classList.add("hide-this");
            }
          });
        }
      }
    }
  });

  observer.observe(el, {
    attributes: true,
    attributeFilter: ['variant'],
  });
});
